import { App } from "./components/App.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
